import { InfoItem } from "@/components/info-item";
import { useAppSelector } from "@/app/appStore";
import { selectSelectedEvent } from "@/entities/annotation";
import { displayUUID, formatAbsoluteCoordinates } from "@/shared";
import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";
import { formatTimestamp } from "../../lib/helpers";
import ProductItem from "../../ui/product-item";

const TransactionEventDetails = () => {
  const selectedEvent = useAppSelector(selectSelectedEvent);

  if (!selectedEvent || selectedEvent.type !== ANNOTATION_TYPES.TRANSACTION) {
    return null;
  }

  const pinCoordinates = formatAbsoluteCoordinates(
    selectedEvent?.pinCoordinates.relativeX,
    selectedEvent?.pinCoordinates.relativeY,
    selectedEvent.cameraImageWidth,
    selectedEvent.cameraImageHeight
  );

  return (
    <>
      <InfoItem label="Event type" value="Journey Transaction Annotation" />
      <InfoItem
        label="Journey ID"
        copyValue={selectedEvent?.journeyId}
        value={displayUUID(selectedEvent?.journeyId)}
      />
      <InfoItem
        label="Order ID"
        value={displayUUID(selectedEvent.orderId)}
        copyValue={selectedEvent.orderId}
      />
      <InfoItem
        label="Annotation ID"
        value={selectedEvent.id ? displayUUID(selectedEvent.id) : undefined}
        copyValue={selectedEvent.id || undefined}
      />
      <InfoItem
        label="Timestamp"
        value={
          selectedEvent?.timestamp && formatTimestamp(selectedEvent?.timestamp)
        }
        copyValue={selectedEvent?.timestamp}
      />
      <InfoItem label="Pin coordinates (x,y)" value={pinCoordinates} />
      <InfoItem
        label="Camera image dimensions"
        value={`${selectedEvent?.cameraImageWidth}x${selectedEvent?.cameraImageHeight}`}
      />
      <InfoItem label="Action" value={selectedEvent.action} />
      <InfoItem label="Camera ID" value={selectedEvent?.cameraId} />
      <InfoItem label="Calibration ID" value={selectedEvent?.calibrationId} />
      <InfoItem label="Gondola name" value={selectedEvent?.gondolaName} />
      <InfoItem label="Gondola ID" value={selectedEvent?.gondolaId} />
      <InfoItem label="Planogram ID" value={selectedEvent?.planogramId} />
      <InfoItem label="Note" value={selectedEvent.notes} />
      <ProductItem
        name={selectedEvent.name}
        imageUrl={selectedEvent.imageUrl}
        barcode={selectedEvent.barcode}
        skuId={selectedEvent.skuId}
        quantity={selectedEvent.count}
        unitOfMeasurement={selectedEvent.uom}
      />
    </>
  );
};

export default TransactionEventDetails;
